import { Skeleton } from "../../components/ui/skeleton";
import { ShieldCheck, Zap } from "lucide-react";

export default function SubscriptionSkeleton() {
  return (
    <div className="max-w-4xl mx-auto py-8 animate-in fade-in duration-500">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-200 overflow-hidden">
        {/* Header Section Skeleton */}
        <div className="p-8 border-b border-slate-100 flex flex-col sm:flex-row items-center gap-6 bg-slate-50/50">
          <Skeleton className="w-24 h-24 rounded-[2rem]" />
          <div className="flex flex-col items-center sm:items-start space-y-3">
            <Skeleton className="h-10 w-64" />
            <Skeleton className="h-4 w-40" />
          </div>
        </div>

        <div className="p-10">
          <div className="space-y-12">
            <div>
              <div className="flex items-center gap-3 mb-8">
                <Skeleton className="w-10 h-10 rounded-xl" />
                <Skeleton className="h-6 w-48" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                {[...Array(3)].map((_, i) => (
                  <div key={i} className="space-y-3">
                    <Skeleton className="h-3 w-24" />
                    <div className="flex items-center gap-2">
                      <Skeleton className="h-7 w-32" />
                      <Skeleton className="h-4 w-12 rounded-lg" />
                    </div>
                  </div>
                ))}
              </div>

              {/* Progress Bar Skeleton */}
              <div className="space-y-4">
                <Skeleton className="h-2 w-full rounded-full" />
                <Skeleton className="h-3 w-32 mx-auto" />
              </div>

              <div className="mt-12 pt-10 border-t border-slate-100 flex gap-4">
                <Skeleton className="h-14 w-48 rounded-2xl" />
                <Skeleton className="h-14 w-48 rounded-2xl" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
